<template>
  <BreadCrumb PageTitle="Modifier une session" />
  <EditSession />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditSession from "@/components/Session/EditSession.vue";

export default defineComponent({
  name: "EditSessionPage",
  components: {
    BreadCrumb,
    EditSession,
  },
});
</script>